import { useTourManager } from '@/components/blocks/TourManager';
import { DriveStep } from 'driver.js';
import { useCallback } from 'react';

const onboardingTourSteps: DriveStep[] = [
	{
		element: '#distributor-navbar-frame',
		popover: {
			title: 'Distribuidor',
			description: 'Esta es la información de tu distribuidor.',
			showButtons: ['next', 'close'],
			nextBtnText: 'Siguiente',
			prevBtnText: 'Anterior',
			doneBtnText: 'Finalizar',
		},
	},
	{
		element: '#header-search-button',
		popover: {
			title: 'Buscar productos',
			description: 'Haz clic aquí para buscar productos en el catálogo.',
			showButtons: ['previous'],
			nextBtnText: 'Siguiente',
			prevBtnText: 'Anterior',
			doneBtnText: 'Finalizar',
		},
	},
	{
		element: '#header-search-input',
		popover: {
			title: 'Busca tus productos',
			description: 'Utiliza la barra de búsqueda para encontrar productos fácilmente.',
			showButtons: ['close'],
			nextBtnText: 'Siguiente',
			prevBtnText: 'Anterior',
			doneBtnText: 'Finalizar',
		},
	},
];

const LOCAL_STORAGE_KEY_ONBOARDING_TOUR_COMPLETED = 'ONBOARDING_TOUR_COMPLETED';

export const useOnboardingTour = () => {
	const { driverInstance, onStartTour } = useTourManager();

	const onFinishOnboardingTour = useCallback(() => {
		if (driverInstance.isActive()) {
			driverInstance.destroy();
		}
	}, [driverInstance]);

	const onStartOnboardingTour = useCallback(() => {
		driverInstance.setSteps(onboardingTourSteps);

		setTimeout(() => {
			onStartTour();
			localStorage.setItem(LOCAL_STORAGE_KEY_ONBOARDING_TOUR_COMPLETED, 'true');
		}, 250);
	}, [onStartTour, driverInstance]);

	const onClickSearchOnboardingTour = useCallback(
		(event: React.MouseEvent<any>, interval?: number) => {
			if (driverInstance.isActive() && driverInstance.getActiveIndex() === 1) {
				event.stopPropagation();
				event.preventDefault();
				setTimeout(() => {
					driverInstance.moveNext();
				}, interval || 0);
			}
		},
		[driverInstance]
	);

	const onAutoStartOnboardingTour = useCallback(() => {
		const hasCompletedTour = localStorage.getItem(LOCAL_STORAGE_KEY_ONBOARDING_TOUR_COMPLETED);
		if (!hasCompletedTour) {
			onStartOnboardingTour();
		}
	}, [onStartOnboardingTour]);

	return {
		onStartOnboardingTour,
		onFinishOnboardingTour,
		onClickSearchOnboardingTour,
		onAutoStartOnboardingTour,
	};
};
